/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerPerFamilyResponse
 */
export interface FreelancerPerFamilyResponse {
    /**
     * 
     * @type {string}
     * @memberof FreelancerPerFamilyResponse
     */
    family: string;
    /**
     * 
     * @type {number}
     * @memberof FreelancerPerFamilyResponse
     */
    freelancerCount: number;
}

/**
 * Check if a given object implements the FreelancerPerFamilyResponse interface.
 */
export function instanceOfFreelancerPerFamilyResponse(value: object): value is FreelancerPerFamilyResponse {
    if (!('family' in value) || value['family'] === undefined) return false;
    if (!('freelancerCount' in value) || value['freelancerCount'] === undefined) return false;
    return true;
}

export function FreelancerPerFamilyResponseFromJSON(json: any): FreelancerPerFamilyResponse {
    return FreelancerPerFamilyResponseFromJSONTyped(json, false);
}

export function FreelancerPerFamilyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerPerFamilyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'family': json['family'],
        'freelancerCount': json['freelancerCount'],
    };
}

export function FreelancerPerFamilyResponseToJSON(value?: FreelancerPerFamilyResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'family': value['family'],
        'freelancerCount': value['freelancerCount'],
    };
}

